import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ICheckbox } from 'codex-lib';
import { Envelope } from '../../model/envelope';
import { SentEnvelopeStatus } from 'src/app/enum/sent-envelope-status';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { SegmentService } from 'src/app/modules/settings/services/segment.service';
import { LanguageBase } from '../../model/language';

@Component({
  selector: 'app-envelope-grid-card-content',
  templateUrl: './envelope-grid-card-content.component.html',
  styleUrls: ['./envelope-grid-card-content.component.scss']
})
export class EnvelopeGridCardContentComponent implements OnInit {

  @Input() envelope: Envelope;
  @Output() cardCheck = new EventEmitter<object>();

  languageBase: LanguageBase;
  segment = new BehaviorSubject<any>(undefined);

  checkbox: ICheckbox = {
    span: '',
  };

  SentEnvelopeStatus = SentEnvelopeStatus;

  constructor(private translate: TranslateService, private segmentService: SegmentService) {
    this.languageBase = new LanguageBase(translate);
   }

  ngOnInit() {
  }

  onCheckbox(checked) {
    this.envelope.checked = checked;
    this.cardCheck.emit(this.envelope);
  }

  onTitleCheckbox(){
    const checked =  this.envelope.checked  ? false : true;
    this.onCheckbox(checked);
  }

  getDateFormat() {
    return this.languageBase.getDateFortmatByLanguage(this.translate.currentLang);
  }

}
